export default __webpack_public_path__ + "static/media/bitsHubBg.e312ffac.webp";